// Home

import skill1 from "../assets/images/skill1.png";
import skill2 from "../assets/images/skill2.png";
import skill3 from "../assets/images/skill3.png";
import skill4 from "../assets/images/skill4.png";
import skill5 from "../assets/images/skill5.png";
import skill6 from "../assets/images/skill6.png";
import skill7 from "../assets/images/skill7.jpg";
// DownloadMinecraft
import step1 from "../assets/images/icons/step1.svg";
import step2 from "../assets/images/icons/step2.svg";
import step3 from "../assets/images/icons/step3.svg";
// teachers guide
import guide1 from "../assets/images/guide1.png";
import guide2 from "../assets/images/guide2.png";
import guide3 from "../assets/images/guide3.png";
// teachers Academy
import academy1 from "../assets/images/academy1.jpg";
import academy2 from "../assets/images/academy2.png";
import academy3 from "../assets/images/academy3.png";
import academy4 from "../assets/images/academy4.png";
import academy5 from "../assets/images/academy5.jpg";
import academy6 from "../assets/images/academy6.png";
// Crafting Table
import CraftingTable1 from "../assets/images/CraftingTable1.png";
import CraftingTable2 from "../assets/images/CraftingTable2.png";
import CraftingTable3 from "../assets/images/CraftingTable3.png";
import CraftingTable4 from "../assets/images/CraftingTable4.png";
import CraftingTable5 from "../assets/images/CraftingTable5.png";
import CraftingTable6 from "../assets/images/CraftingTable6.png";
import { LinkArrow } from "./UI/svgIcons.jsx";

export const HomeContent = {
  title: {
    title: "Join the exciting journey to build your digital and AI skills!",
    buttonText: "Let's go!",
    paragraph:
      "Click on the tiles below to unlock fantastic teacher guides and resources. Sign up for a Play-Along, streamed directly to your classroom, or take part in the EU Code Week Build Challenge."
  },
  content: [
    {
      image: skill1,
      title: "Teacher Academy",
      paragraph: [
        "Prepare for EU CodeWeek with all the Minecraft Education material you’ll need to get started."
      ],
      link: "/teacher-academy"
    },
    {
      image: skill2,
      title: "Access Teacher Guides & Resources",
      paragraph: [
        "Click on this tile to unlock fantastic guides and resources designed by and for educators, to help you get the most out of Minecraft Education."
        // "Dive in and have fun!"
      ],
      link: "/teacher-guide"
    },
    {
      image: skill3,
      title: "PlayAlong - Hour of Code: Generation AI",
      paragraph: [
        "Stay tuned launching October 11th, Join Dream Space educators Michael Barrett and Neeve Hyland as they guide your class on a journey through time to create innovative, AI-powered inventions in Minecraft Education. No Minecraft Education license is needed to participate in this session."
      ],
      link: "https://aka.ms/EUCODEAI"
    },
    {
      image: skill4,
      title: "PlayAlong - AI for Earth",
      paragraph: [
        "Stay tuned launching October 11th, Join Dream Space educators Michael Barrett and Neeve Hyland as they guide you through the first step of your journey in the AI for Earth series where we explore how AI-powered tools can help with animal conservation. A Minecraft Education license is needed to participate in this session"
      ],
      link: "https://aka.ms/EUCODEEARTH"
    },
    {
      image: skill5,
      title: "PlayAlong - Cybersafe AI: Dig Deeper",
      paragraph: [
        "Stay tuned launching October 11th, Join Dream Space educators Michael Barrett and Neeve Hyland as they guide your class through the newest Cybersafe installment, Dig Deeper! Participate in this interactive experience that empowers learners to think critically and use AI responsibly!"
      ],
      link: "https://aka.ms/EUCODEDIGDEEPER"
    },
    {
      image: skill6,
      title: "PlayAlong - Fantastic Fairgrounds",
      paragraph: [
        "Stay tuned launching October 11th, Join Dream Space educators Michael Barrett and Neeve Hyland for an exciting journey into the world of AI! Explore how we can ensure responsible AI practices in the world around us while visiting a virtual fairground. No Minecraft Education license is needed to participate in this session."
      ],
      link: "https://aka.ms/EUCODEFAIR"
    },
    {
      image: skill7,
      title: "The Crafting Table",
      paragraph: [
        "The Crafting Table is a bite-sized video series for educators that demonstrates how to use Minecraft Education and the AI-powered Lesson Crafter tool to easily transform core curriculum lessons into creative, interactive learning experiences across subjects."
      ],
      link: "/crafting-table"
    }
  ]
};

export const DownloadMinecraftContent = {
  title: {
    title: "Download and Sign In to Minecraft Education",
    paragraph: "To download and access Minecraft Education"
  },
  steps: [
    {
      icon: step1,
      title: "STEP 1",
      paragraph:
        "Click on the link below to download Minecraft Education (this will open a new tab or window on your device)",
      button: [
        {
          text: "Download Minecraft Education",
          link: "https://education.minecraft.net/en-us/get-started/download",
          target: "_blank"
        }
      ]
    },
    {
      icon: step2,
      title: "STEP 2",
      paragraph:
        "Once the download is completed, install the application on your device and open the application “Minecraft Education”."
    },
    {
      icon: step3,
      title: "STEP 3",
      paragraph:
        "Log in to Minecraft Education using your school or university credentials. You will then be presented with one of three screens.",
      button: [
        {
          text: "Next",
          link: "/download",
          target: "_self"
        }
      ]
    }
  ]
};

export const DreamSpaceContent = {
  title: {
    title: "Dream Space TV",
    paragraph:
      "Dream Space TV is a comprehensive package of on-demand resources for use in primary, post-primary or youth group settings which guides young people on a learning journey focused on computational thinking, digital creativity and problem-solving. Our Dream Space TV resources are designed for off-the-shelf use by teachers and facilitators, with clear guidelines as to age, activity, and curricular links."
  },
  content: [
    {
      title: "Dream Space TV ByteSize",
      color: "rgba(207, 5, 59, 1)",
      link: "https://aka.ms/DSTVBytesize",
      icon: LinkArrow
    },
    {
      title: "Dream Space TV for Primary: STEAM series",
      color: "rgba(220, 5, 43, 1)",
      link: "https://forms.microsoft.com/pages/responsepage.aspx?id=v4j5cvGGr0GRqy180BHbRw1p_hdLj5ZJjeb27xtnZsBUNjFXUE4yRTRWNDg5SldWQ1ZYWlZPNVBPRi4u&route=shorturl",
      icon: LinkArrow
    },
    {
      title: "Dream Space TV: brAIn_waves for primary schools",
      color: "rgba(232, 83, 14, 1)",
      link: "https://aka.ms/DSTVbrAInWavesPrimary",
      icon: LinkArrow
    },
    {
      title: "Dream Space TV: Ireland’s Future is MINE",
      color: "rgba(243, 149, 0, 1)",
      link: "https://aka.ms/DSTVIFIM",
      icon: LinkArrow
    },
    {
      title: "Dream Space TV: Code Green series",
      color: "rgba(224, 48, 90, 1)",
      link: "https://aka.ms/DSTVCodeGreen",
      icon: LinkArrow
    },
    {
      title: "Dream Space TV for Post-Primary",
      color: "rgba(232, 19, 128, 1)",
      link: "https://aka.ms/DSTVPostPrimary",
      icon: LinkArrow
    },
    {
      title: "Dream Space TV: brAIn_waves for post-primary schools",
      color: "rgba(185, 11, 126, 1)",
      link: "https://aka.ms/DSTVbrAInWavesPostPrimary",
      icon: LinkArrow
    },
    {
      title: "Dream Space TV as Gaeilge",
      color: "rgba(148, 25, 127, 1)",
      link: "https://aka.ms/DSTVasGaeilge",
      icon: LinkArrow
    }
  ],
  teacherPackage: {
    title: {
      title: "Dream Space Teacher Packages",
      paragraph:
        "We believe in listening to teachers! Our aim is to provide them with access to the resources and the support they need to assist them in their schools. Our Dream Space Career Guidance resources have been developed to support guidance counsellors and students, with inputs from the STEM and Technology Industry, and to help demystify what key IT jobs entail, and to spark student curiosity in the huge range of career pathways available to them."
    },
    content: [
      {
        title: "Computational Thinking with micro:bit - for primary",
        color: "rgba(178, 212, 250, 1)",
        btnColor: "rgba(0, 100, 224, 1)",
        link: "https://aka.ms/DSTeacherCompT"
      },
      {
        title: "Gamifying STEAM with MakeCode Arcade - for primary ",
        color: "rgba(255, 208, 209, 1)",
        btnColor: "rgba(201, 46, 52, 1)",
        link: "https://aka.ms/DSTeacherArcadePrimary"
      },
      {
        title:
          "Coding Through Game Design with MakeCode Arcade - for post-primary",
        color: "rgba(255, 227, 200, 1)",
        btnColor: "rgba(204, 57, 26, 1)",
        link: "https://forms.office.com/pages/responsepage.aspx?id=v4j5cvGGr0GRqy180BHbRw1p_hdLj5ZJjeb27xtnZsBURDZCUDc2NVpBM0pHMk1XR1AxOEIwNVM5Ny4u&route=shorturl"
      },
      {
        title: "Programming with Python - for post-primary",
        color: "rgba(228, 216, 251, 1)",
        btnColor: "rgba(88, 52, 190, 1)",
        link: "https://forms.office.com/pages/responsepage.aspx?id=v4j5cvGGr0GRqy180BHbRw1p_hdLj5ZJjeb27xtnZsBURVhLUzRVWkVMTUFXUVBMN082MFFKUEtSWC4u&route=shorturl"
      }
    ]
  },
  careerGuidance: {
    title: {
      title: "Dream Space in Career Guidance",
      paragraph:
        "We believe in listening to teachers in the education system and providing access to resources and information that supports them based in their schools. Our Dream Space in Career Guidance resources have been developed to support career guidance counsellors and students with inputs from the STEM and technology industry to demystify what these jobs entail and spark curiosity in areas never considered."
    },
    content: [
      {
        title:
          "Dream Space Champion: STEAM Careers Resource for Career Classes",
        color: "rgba(178, 212, 250, 1)",
        btnColor: "rgba(0, 100, 224, 1)",
        link: "https://forms.office.com/Pages/ResponsePage.aspx?id=v4j5cvGGr0GRqy180BHbRw1p_hdLj5ZJjeb27xtnZsBURVhCWklTQ09CSFFSSk5GOVM2Uk5aUlpESi4u"
      }
    ]
  }
};

export const PrivacyPolicyContent = {
  title: {
    title: "Privacy Policy",
    date: "Last updated: October 11, 2024",
    paragraph: [
      "This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.",
      "We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy."
    ]
  },
  content: [
    {
      mainTitle: "Interpretation and Definitions"
    },
    {
      title: "Interpretation",
      paragraph: [
        "The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural."
      ]
    },
    {
      title: "Definitions",
      paragraph: [
        "For the purposes of this Privacy Policy:",
        "Account: means account used by You to access our Service or parts of our Service.",
        '<b>Company:</b> (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to ‘Terawe International’.',
        "<b>Cookies:</b> are small files that are placed on Your computer, mobile device or any other device by a website, containing the details of Your browsing history on that website among its many uses.",
        "<b>Country:</b>  refers to any country within the European Union that you are accessing the data from",
        "<b>Device:</b> means any device that can access the Service such as a computer, a cellphone or a digital tablet.",
        "<b>Personal Data:</b> is any information that relates to an identified or identifiable individual.",
        "<b>Service:</b> refers to the Website.",
        "<b>Service Provider:</b> means any natural or legal person who processes the data on behalf of the Company. It refers to third-party companies or individuals employed by the Company to facilitate the Service, to provide the Service on behalf of the Company, to perform services related to the Service or to assist the Company in analyzing how the Service is used. ",
        "<b>Third-party Social Media Service:</b> refers to any website or any social network website through which a User can reach the Service.",
        "<b>Usage Data:</b> refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).",
        "<b>Website:</b> refers to Minecraft Education for Code Week, a Terawe Website accessible from <a href='www.minecraftedu4codeweek.eu' taret='_blank'>www.minecraftedu4codeweek.eu</a> ",
        "<b>You:</b> means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable."
      ]
    },
    {
      mainTitle: "Collecting and Using Your Personal Data"
    },
    {
      title: "Types of Data Collected",
      subTitle: "Personal Data",
      paragraph: [
        "While using Our Service, We may ask You to provide Us with certain personally identifiable information that can be used to contact or identify You. Personally identifiable information may include, but is not limited to:"
      ],
      list: ["Email address", "First name and last name", "School Name"]
    },
    {
      subTitle: "Usage Data",
      paragraph: ["Usage Data is not collected when using the Service."]
    },
    {
      subTitle: "Tracking Technologies and Cookies",
      paragraph: [
        "We do not use Cookies and similar tracking technologies to track the activity on Our Service or store any information."
      ]
    },
    {
      subTitle: "Use of Your Personal Data",
      paragraph: [
        "The Company may use Personal Data for the following purposes:"
      ],
      list: [
        "To provide and maintain our Service: including to monitor the usage of our Service.",
        "For the performance of a contract:  the development, compliance and undertaking of the purchase contract for the products, items or services You have purchased or of any other contract with Us through the Service.",
        "To contact You:  by email, telephone calls, SMS, or other equivalent forms of electronic communication, such as a mobile application's push notifications regarding updates or informative communications related to the functionalities, products or contracted services, including the security updates, when necessary or reasonable for their implementation.",
        "To provide You: with news, special offers and general information about other goods, services and events which we offer that are similar to those that you have already purchased or enquired about unless You have opted not to receive such information.",
        "To manage Your requests:  To attend and manage Your requests to Us.",
        "For other purposes:  We may use Your information for other purposes, such as data analysis, identifying usage trends, determining the effectiveness of our promotional campaigns and to evaluate and improve our Service, products, services, marketing and your experience."
      ]
    },
    {
      mainTitle: "Sharing of Your Personal Data"
    },
    {
      paragraph: [
        "We may share Your personal information in the following situations:"
      ],
      list: [
        "With Service Providers:  We may share Your personal information with Service Providers to monitor and analyze the use of our Service, to contact You."
      ]
    },
    {
      mainTitle: "Retention of Your Personal Data"
    },
    {
      paragraph: [
        "The Company will retain Your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy."
      ]
    },
    {
      mainTitle: "Transfer of Your Personal Data"
    },
    {
      paragraph: [
        "Your information, including Personal Data, is processed at the Company's operating offices and in any other places where the parties involved in the processing are located.",
        "Your consent to this Privacy Policy followed by Your submission of such information represents Your agreement to that transfer.",
        "The Company will take all steps reasonably necessary to ensure that Your data is treated securely and in accordance with this Privacy Policy and no transfer of Your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of Your data and other personal information."
      ]
    },
    {
      mainTitle: "Security of Your Personal Data"
    },
    {
      paragraph: [
        "The security of Your Personal Data is important to Us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While We strive to use commercially acceptable means to protect Your Personal Data, We cannot guarantee its absolute security."
      ]
    },
    {
      mainTitle: "Deletion of Your Personal Data"
    },
    {
      paragraph: [
        "You can, at any time, request the deletion of your data by reaching out to us using the Contact information detailed below."
      ]
    },
    {
      mainTitle: "Children's Privacy"
    },
    {
      paragraph: [
        "Our Service does not address anyone under the age of 13. We do not knowingly collect personally identifiable information from anyone under the age of 13. If You are a parent or guardian and You are aware that Your child has provided Us with Personal Data, please contact Us. If We become aware that We have collected Personal Data from anyone under the age of 13 without verification of parental consent, We take steps to remove that information from Our servers.",
        "If We need to rely on consent as a legal basis for processing Your information and Your country requires consent from a parent, We may require Your parent's consent before We collect and use that information."
      ]
    },
    {
      mainTitle: "Links to Other Websites"
    },
    {
      paragraph: [
        "Our Service may contain links to other websites that are not operated by Us. If You click on a third party link, You will be directed to that third party's site. We strongly advise You to review the Privacy Policy of every site You visit.",
        "We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services."
      ]
    },
    {
      mainTitle: "Changes to this Privacy Policy"
    },
    {
      paragraph: [
        "You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.",
        "We may update Our Privacy Policy from time to time. We will notify You of any changes by posting the new Privacy Policy on this page."
      ]
    },
    {
      mainTitle: "Contact Us"
    },
    {
      title: "Interpretation",
      paragraph: [
        "If you have any questions about this Privacy Policy, You can contact us at <a href='mailto:edusup@terawe.com'>edusup@terawe.com</a> "
      ]
    }
  ]
};

export const TeachersGuide = {
  title: {
    title: "Access Teacher Guides and Resources",
    paragraph:
      "Explore the principles of Responsible AI and discover ways AI can help us solve a range of problems, with free Minecraft Education coding lessons and teaching & learning activities."
  },
  content: [
    {
      image: guide1,
      title: "Explore Lesson Plans & Educator Resources",
      paragraph: [
        "Minecraft Education provides over 200 hours of free Computer Science content for all skill levels, with training materials designed by and for educators. Coding has never been more fun!"
      ],
      link: "https://education.minecraft.net/en-us/resources/computer-science"
    },
    {
      image: guide2,
      title: "Access Resources & Training",
      paragraph: [
        "Our Professional Learning Program helps you to integrate Minecraft Education into your teaching – regardless of your coding or IT experience! Access free, on-demand training and sign up today!"
      ],
      link: "https://education.minecraft.net/en-us/resources/get-trained"
    },
    {
      image: guide3,
      title: "Explore Dream Space",
      paragraph: [
        "Dream Space at Microsoft Ireland provides immersive, research-based STEM experiences for students, teachers and communities to enhance their STEM skills alongside crucial social-emotional skills such as empathy, creativity, ethical decision making and collaboration. Dream Space empowers everyone to see the power of digital technology and STEM in exciting new ways and the crucial role that these areas have now and into the future through a variety of free programming, open to all education communities."
      ],
      link: "https://dreamspace.microsoft.com/en-us/dreamspace/ireland"
    }
  ]
};

export const TeachersAcademy = {
  title: {
    title: "Teacher Training Academy"
  },
  content: [
    {
      image: academy1,
      title: "EU Code Week: Teacher Readiness Workshop",
      paragraph: [
        "Get prepared for EU Code Week with a quick, on-demand session that shows how to bring Minecraft Education into your lessons. Learn practical tips, themed build ideas and AI-focused play-alongs that will help you deliver engaging hands-on coding activities for your students."
      ],
      link: "https://aka.ms/EUCODE101"
    },
    {
      image: academy2,
      title: "AI Foundations for Educators Training with Certification",
      paragraph: [
        "Discover how to teach AI literacy with Minecraft Education and Microsoft Copilot in this hands-on, on-demand session. Explore interactive demos and ready-to-use resources that make AI concepts engaging and accessible for your students, even if you’re new to AI or Minecraft."
      ],
      link: "https://aka.ms/AIFoundationsTraining"
    },
    {
      image: academy3,
      title: "MTA 101: Crafting a Game-Based Learning Classroom",
      paragraph: [
        "Start your Minecraft Education journey with this beginner-friendly, on-demand session that shows how game-based learning can boost engagement, creativity and critical thinking. Learn the basics of navigating Minecraft Education and discover ready-made lessons and worlds you can use straight away in your classroom."
      ],
      link: "https://aka.ms/MTA101ondemand"
    },
    {
      image: academy4,
      title: "MTA 201: Making Assessment and Learning Mine",
      paragraph: [
        "Discover how to use Minecraft Education to capture and assess student learning in creative, meaningful ways. Learn to harness in-game tools like the Camera, Portfolio, Book & Quill and Chalkboards to make formative and summative assessment more visible, engaging and student-centred."
      ],
      link: "https://aka.ms/MTA201ondemand"
    },
    {
      image: academy5,
      title: "MTA 301: Programming Future-Ready Skills",
      paragraph: [
        "Learn how to introduce coding and computational thinking with Minecraft Education using built-in tools like Code Builder. Explore ready-made coding challenges and curriculum resources that make it easy to build creativity, problem-solving and digital fluency in your classroom."
      ],
      link: "https://aka.ms/MTA301ondemand"
    },
    {
      image: academy6,
      title: "MTA 401: Building Towards Project-Based Learning",
      paragraph: [
        "Discover how to use Minecraft Education to create meaningful project-based learning experiences that foster inquiry, creativity and collaboration. Learn to design build challenges, run multiplayer sessions and use AI tools to guide students through authentic, curriculum-linked projects."
      ],
      link: "https://aka.ms/MTA401ondemand"
    }
  ]
};

export const CraftingTableContent = {
  title: {
    title: "The Crafting Table",
    paragraph:
      "The Crafting Table is a bite-sized video series for educators that demonstrates how to use Minecraft Education and the AI-powered Lesson Crafter tool to easily transform core curriculum lessons into creative, interactive learning experiences across subjects."
  },
  content: [
    {
      image: CraftingTable1,
      title: "The Crafting Table | Shape Shifters",
      paragraph: [
        "Discover how 3D shapes come to life in Minecraft as students explore faces, edges and vertices through a simple creative build challenge."
      ],
      link: "https://aka.ms/ShapeShifters"
    },
    {
      image: CraftingTable2,
      title: "The Crafting Table | Cell Builders",
      paragraph: [
        "Take science into your students' hands with this interactive biology lesson where Minecraft becomes the lab for building plant and animal cells."
      ],
      link: "https://aka.ms/CellBuilders"
    },
    {
      image: CraftingTable3,
      title: "The Crafting Table | Hello Blocky World",
      paragraph: [
        "Jumpstart your students’ coding journey in Minecraft Education by exploring either block-based or Python coding through a hands-on “Hello World” skywriting challenge."
      ],
      link: "https://aka.ms/HelloBlockyWorld"
    },
    {
      image: CraftingTable4,
      title: "The Crafting Table | Comic Craft",
      paragraph: [
        "Reimagine your students’ favourite scenes from a novel or story with this creative literacy lesson, where familiar narratives are transformed into Minecraft comic strips."
      ],
      link: "https://aka.ms/ComicCraft"
    },
    {
      image: CraftingTable5,
      title: "The Crafting Table | Sailing Through Time",
      paragraph: [
        "Explore history and culture through the design of boats as students investigate and recreate vessels from across time in Minecraft."
      ],
      link: "https://aka.ms/SailingThroughTime"
    },
    {
      image: CraftingTable6,
      title: "The Crafting Table | Zoo Designers",
      paragraph: [
        "Step into the role of a wildlife specialist as students apply perimeter and area to design zoo enclosures in Minecraft, balancing mathematical accuracy with the needs of their chosen animals."
      ],
      link: "https://aka.ms/ZooDesigners"
    }
  ]
};
